module.exports = __webpack_public_path__ + "img/662561a.png";